<template>
  <el-dialog
    width="1024px"
    :title="showFast ? '' : 'Chi tiết lịch sử phê duyệt'"
    :visible="visible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <ApprovedHistory
      v-show="!showFast"
      :contract-id="contract.id"
      :document="item"
      :show-fast="showFast"
      @close="$emit('close')"
    />
    <div
      v-if="showFast"
      v-loading="showFast"
      style="min-height: 100px"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="medium"
        :disabled="showFast"
        @click="handleClose"
      >
        Đóng
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApprovedHistory from "../components/History.vue";

export default {
  name: "ApprovedHistoryPopup",
  components: {
    ApprovedHistory
  },
  props: {
    item: Object,
    contract: Object,
    visible: Boolean,
    showFast: Boolean
  },
  methods: {
    handleClose() {
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss" scoped></style>
